<template>
  <div
    class="lv-content-tab"
    :class="{activiated:activiated,wide:wide}"
    :style="{'min-width':contentWidth+'px'}"
    @click="onclick()"
  >
    <button>
      {{ $t(textLabel) }}
      <WsLoading v-if="isLoading" primary class="ml-8"/>
      <p
        v-else-if="num"
        class="num"
      >
        {{ num }}
      </p>
      <p
        v-if="doneIcon"
        class="done-icon"
      >
        <i class="icon-check-circle-filled" />
      </p>
    </button>
  </div>
</template>

<script>
export default {
  name: "LvContentTab001",
  props: {
    doneIcon: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: "",
    },
    activiated: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    contentWidth: {
      type: Number,
      default: 122,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick() {
      this.$emit("click");
    },
  },
};
</script>